import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import { ReactComponent as X } from 'assets/icons/X.svg';

type CloseButtonProps = {
  className?: string;
  onClick: () => void;
  iconClassName?: string;
  variant?: 'default' | 'ghost';
};

const CloseButton = ({ className, onClick, iconClassName, variant = 'default' }: CloseButtonProps) => {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      className={cx(
        'flex h-8 w-8 cursor-pointer items-center justify-center rounded-xl p-2.5 text-black transition-colors duration-300',
        variant === 'default' && 'bg-white hover:bg-gray-30',
        variant === 'ghost' && 'bg-transparent hover:bg-gray-20',
        className
      )}
      onClick={onClick}
      aria-label={t('close')}
    >
      <X className={cx('h-5 w-5 shrink-0 stroke-current', iconClassName)} />
    </button>
  );
};

export default CloseButton;
